import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatError, BRAND } from "../lib/api";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex bg-brand-navy text-white p-12 flex-col justify-between relative overflow-hidden">
        <div className="relative z-10">
          <img src={BRAND.logoHorizontal} alt="KenMarq" className="h-14 bg-white/5 rounded-xl px-3 py-2 max-w-xs" />
        </div>
        <div className="relative z-10">
          <span className="font-script text-4xl text-brand-amber">Admin</span>
          <h1 className="font-display text-4xl font-extrabold tracking-tight mt-2">Manage classes, registrations, and inquiries.</h1>
        </div>
        <div className="absolute -right-20 -bottom-20 opacity-10">
          <ShieldCheck className="h-96 w-96" />
        </div>
      </div>

      <div className="flex items-center justify-center p-8 bg-brand-cream">
        <form onSubmit={submit} className="w-full max-w-md space-y-5 bg-white p-8 rounded-3xl border border-slate-200" data-testid="admin-login-form">
          <div>
            <h2 className="font-display text-3xl font-extrabold text-brand-navy tracking-tight">Admin Sign In</h2>
            <p className="mt-2 text-slate-600 text-sm">Owner access to the KenMarq dashboard.</p>
          </div>
          <div>
            <Label className="text-brand-navy font-semibold">Email</Label>
            <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 bg-brand-surface border-slate-200 rounded-lg" data-testid="login-email" />
          </div>
          <div>
            <Label className="text-brand-navy font-semibold">Password</Label>
            <Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 bg-brand-surface border-slate-200 rounded-lg" data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-brand-coral hover:bg-brand-coral-dark text-white rounded-full py-6 font-bold btn-lift" data-testid="login-submit">
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
